import React from "react";
import { MenuItem, Card, Typography } from "@mui/material";
import Grid from "@mui/material/Grid";
import Select from "@mui/material/Select";

export function SelectorHonorario({
  sindicato,
  setSindicato,
  sindicatos,
  setMes,
  mes,
  meses,
  anio,
  setAnio,
  anios,
  setCategoria,
  categorias,
  categoria,
}) {
  return (
    <Card
      style={{
        padding: "0.8rem",
        backgroundColor: "#f0f0f0",
        color: "#2c2c2c",
      }}
    >
      <Grid container spacing={2}>
        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          style={{ display: "flex", alignItems: "center" }}
        >
          <Typography variant="body2" style={{ margin: 0 }} gutterBottom>
            Sindicato:
          </Typography>
          <Select
            style={{ minWidth: "180px", marginLeft: "8px" }}
            onChange={(e) => setSindicato(e.target.value)}
            value={sindicato}
          >
            {sindicatos.map((s) => (
              <MenuItem key={s.id} value={s.id}>
                {s.nombre}
              </MenuItem>
            ))}
          </Select>
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          style={{ display: "flex", alignItems: "center" }}
        >
          <Typography variant="body2" style={{ margin: 0 }} gutterBottom>
            Categoría:
          </Typography>
          <Select
            style={{ minWidth: "180px", marginLeft: "8px" }}
            onChange={(e) => setCategoria(e.target.value)}
            value={categoria}
          >
            {categorias.map((s) => (
              <MenuItem key={s.id} value={s.id}>
                {s.nombre}
              </MenuItem>
            ))}
            <MenuItem value={-2} disabled>
              -- Seleccionar Categoria --
            </MenuItem>
          </Select>
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          style={{ display: "flex", alignItems: "center" }}
        >
          <Typography variant="body2" style={{ margin: 0 }} gutterBottom>
            Mes:
          </Typography>
          <Select
            style={{ minWidth: "180px", marginLeft: "8px" }}
            onChange={(e) => setMes(e.target.value)}
            value={mes}
          >
            {meses.map((m) => (
              <MenuItem key={m.id} value={m.id}>
                {m.nombre}
              </MenuItem>
            ))}
          </Select>
        </Grid>

        <Grid
          item
          xs={12}
          sm={6}
          md={4}
          style={{ display: "flex", alignItems: "center" }}
        >
          <Typography variant="body2" style={{ margin: 0 }} gutterBottom>
            Año:
          </Typography>
          <Select
            style={{ minWidth: "180px", marginLeft: "8px" }}
            onChange={(e) => setAnio(e.target.value)}
            value={anio}
          >
            {anios.map((a) => (
              <MenuItem key={a.anio} value={a.anio}>
                {a.anio}
              </MenuItem>
            ))}
          </Select>
        </Grid>

        
      </Grid>
    </Card>
  );
}
